<!-- 
<div id="jstree"></div>
<input id="file-input" type="file" style="display:none" (change)="handleFileInput($event)" />
-->

<!-- TipoExplorador = plantilla | expendiente-->
<app-file-explorer [tipoExplorador]="'plantilla'"></app-file-explorer>

